import { Job, JobsClient, JobsRequest } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const jobsClient = new JobsClient(undefined, axios);

// TODO: should always return an empty array instead of null
export const useJobs = (jobsRequest: JobsRequest | undefined, options?: any) => {
  return useQuery<Job[] | null>({
    ...options,
    queryKey: ["jobs"],
    initialData: null,
    queryFn: async () => jobsRequest ? jobsClient.getJobs(jobsRequest) : new Promise((resolve) => resolve(null)),
  });
};




